import { Component, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';

import { SuperTokensConfig } from "src/app/supertokens/config";

import * as SuperTokens from "supertokens-auth-react";

SuperTokens.init(SuperTokensConfig);
SuperTokens.changeLanguage("it");

export const _DEBUG = !environment.production;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'taBiz';

  public vh: any;

  ngOnInit(): void {
    this.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.vh = window.innerHeight * 0.01;
    if (_DEBUG) console.log(window.innerHeight)
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
  }

  /*** 
   * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
   * ***/
}
